<template>
  <div
    class="sortable-header-cell"
    :class="[order, { active }]"
    @click="toggleSort"
  >
    {{ label }}
    <img :src="arrowIcon">
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'SortableHeaderCell',
  props: {
    field: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('customMarket', {
      currentSortOrder: 'sortOrder',
      currentSortField: 'sortField',
    }),
    order() {
      return this.active ? this.currentSortOrder : 'desc';
    },
    active() {
      return this.currentSortField === this.field;
    },
    /* eslint-disable global-require, import/no-dynamic-require */
    arrowIcon() {
      if (this.active) return require('@/assets/icon-dropdown-orange.svg');
      return require('@/assets/icon-dropdown.svg');
    },
    /* eslint-enable global-require, import/no-dynamic-require */
  },
  methods: {
    ...mapMutations('customMarket', ['setSortField', 'setSortOrder']),
    toggleSort() {
      if (!this.active) {
        this.setSortField(this.field);
        return;
      }
      const order = this.currentSortOrder === 'asc' ? 'desc' : 'asc';
      this.setSortOrder(order);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variables";

.sortable-header-cell {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;

  img {
    display: inline-block;
    margin-left: 15px;
  }

  &.asc {
    img {
      transform: rotate(180deg);
    }
  }

  &.active {
    color: $orange;
  }
}
</style>
